import { useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';

export default function Colon({ children, text, fill, stroke }) {

    const [style, setStyle] = useState({
        stroke: "#bdbfc1",
        strokeWidth: 50,
        strokeMiterlimit: 22.9256,
    })

    useEffect(() => {
        setStyle({
            stroke: stroke,
            strokeWidth: 50,
            strokeMiterlimit: 22.9256, 
            fill: fill
        })
    }, [fill, stroke])

    const tooltipText = <p>Colon<br />{text}</p>

    return (
        <Tooltip title={tooltipText} arrow placement="left" PopperProps={{sx:{
            "& .MuiTooltip-tooltip": {
                fontSize: 12,
                fontWeight: "bold"
              }
        }}}>
            <svg
                xmlSpace="preserve"
                width={49.822}
                height={49.822}
                style={{
                    clipRule: "evenodd",
                    fillRule: "evenodd",
                    imageRendering: "optimizeQuality",
                    shapeRendering: "geometricPrecision",
                    textRendering: "geometricPrecision",
                }}
                viewBox="0 0 1318.2 1318.2"
                id="svg154"
                xmlns="http://www.w3.org/2000/svg"
                {...children}
            >
                <defs id="defs20">
                    <style type="text/css" id="style18">
                        {
                            ".str1{stroke:#373435;stroke-width:52.92;stroke-miterlimit:22.9256}.fil2{fill:none}"
                        }
                    </style>
                </defs>
                <g id="Layer_x0020_1" transform="translate(-15456.04 -15866.679)">
                    <g id="_2033462332976">
                        <circle
                            className="fil2"
                            cx={16115.14}
                            cy={16525.779}
                            r={623.82}
                            id="circle146"
                            style={style}
                        />
                        <path
                            className="fil2 str1"
                            d="M16000.13 16398.1c2.21 5.75 4.42 11.5 5.75 17.48 1.33 5.97 1.77 12.17.88 20.14-.88 7.96-3.09 17.7-7.52 25.89-4.43 8.18-11.06 14.82-11.95 20.13-.88 5.31 3.98 9.29 8.19 16.6 4.2 7.3 7.74 17.92 8.41 26.77.66 8.85-1.55 15.93-4.43 22.57-2.88 6.64-6.42 12.84-6.19 17.49.22 4.64 4.2 7.74 9.73 14.6 5.53 6.86 12.62 17.48 15.49 27 2.88 9.51 1.55 17.92-.44 25.89-1.99 7.96-4.65 15.49-1.33 27.43 3.32 11.95 12.61 28.33 16.6 42.05 3.98 13.72 2.65 24.78-1.77 35.18-4.43 10.4-11.95 20.14-22.79 25.89-10.85 5.76-25.01 7.53-38.73 6.2-13.72-1.33-27-5.75-36.95-12.84-9.96-7.08-16.6-16.81-20.36-26.11-3.76-9.29-4.65-18.14-3.32-25 1.33-6.86 4.87-11.73 4.2-16.38-.66-4.64-5.53-9.07-11.5-15.71-5.98-6.64-13.06-15.49-17.04-23.23-3.98-7.75-4.87-14.39-2.88-21.91 1.99-7.52 6.86-15.93 8.85-21.02 1.99-5.09 1.11-6.86-2.65-11.07-3.76-4.2-10.4-10.84-13.94-21.02-3.54-10.18-3.99-23.9-1.77-35.62 2.21-11.73 7.08-21.47 10.18-27.44 3.09-5.98 4.42-8.19 2.21-11.73-2.21-3.54-7.97-8.41-12.39-18.14-4.43-9.74-7.53-24.35-7.08-34.97.44-10.62 4.42-17.26 9.07-23.9 4.65-6.64 9.96-13.27 10.62-21.02.66-7.74-3.32-16.59-4.87-26.55-1.55-9.96-.66-21.02 1.99-30.98 2.66-9.96 7.08-18.81 14.83-26.11 7.74-7.31 18.81-13.06 27.88-17.26 9.07-4.21 16.15-6.86 26.77-12.62 10.63-5.75 24.79-14.6 39.39-18.36 14.61-3.76 29.66-2.44 41.16 1.33 11.51 3.76 19.48 9.95 24.34 10.4 4.87.44 6.64-4.87 14.16-8.41 7.53-3.54 20.81-5.31 34.3-5.53 13.5-.23 27.22 1.1 39.39 4.2 12.17 3.1 22.79 7.97 30.98 7.3 8.19-.66 13.94-6.86 24.12-10.62 10.18-3.76 24.79-5.09 38.06-3.98 13.28 1.1 25.23 4.64 34.08 9.51 8.85 4.87 14.6 11.07 18.59 12.17 3.98 1.11 6.19-2.87 11.95-6.19 5.75-3.32 15.04-5.98 25.44-5.98 10.4 0 21.91 2.66 32.09 8.19 10.18 5.53 19.03 13.94 30.76 22.57s26.33 17.48 33.85 27.44c7.53 9.96 7.97 21.02 7.53 33.86-.45 12.83-1.77 27.43 1.1 40.05 2.88 12.61 9.96 23.23 15.94 34.96 5.97 11.73 10.84 24.56 11.06 36.95.22 12.39-4.2 24.34-5.97 35.41-1.77 11.06-.89 21.24-.67 32.09.22 10.84-.22 22.34-4.65 32.97-4.42 10.62-12.83 20.35-16.15 31.86-3.32 11.51-1.55 24.78-2.43 36.95-.89 12.17-4.43 23.24-11.29 31.43-6.86 8.18-17.04 13.49-21.91 21.9-4.86 8.41-4.42 19.92-6.19 28.99-1.77 9.07-5.75 15.71-10.4 22.79-4.65 7.08-9.96 14.61-16.6 18.37-6.64 3.76-14.6 3.76-23.01 6.86-8.41 3.1-17.26 9.29-26.11 13.28-8.85 3.98-17.71 5.75-26.11 4.2-8.41-1.55-16.38-6.42-21.03-8.63-4.64-2.21-5.97-1.77-6.85 4.43-.89 6.19-1.33 18.14-4.43 31.2-3.1 13.05-8.85 27.21-11.73 34.29-2.87 7.09-2.87 7.09-6.64-1.77-3.76-8.85-11.28-26.55-14.82-44.25-3.54-17.7-3.1-35.41 1.33-48.02 4.42-12.61 12.83-20.14 25.44-23.46 12.62-3.31 29.43-2.43 38.06-7.52 8.63-5.09 9.07-16.15 10.62-24.12 1.55-7.97 4.21-12.83 8.86-17.48 4.64-4.65 11.28-9.07 13.49-17.04 2.22-7.96 0-19.47-1.1-29.87-1.11-10.4-1.11-19.7 4.87-30.1 5.97-10.4 17.92-21.9 23.23-28.54 5.31-6.64 3.98-8.41.22-16.38-3.76-7.96-9.96-22.12-10.84-36.95-.89-14.83 3.54-30.32 7.3-42.71s6.86-21.68 5.31-31.2c-1.55-9.51-7.74-19.25-14.82-30.09-7.09-10.84-15.05-22.79-18.37-30.98-3.32-8.19-1.99-12.61-.66-17.04"
                            id="path148"
                        />
                        <path
                            className="fil2 str1"
                            d="M15924.45 16346.32c8.85 7.08 17.7 14.16 27.66 19.91 9.95 5.76 21.02 10.18 29.21 15.27 8.18 5.09 13.49 10.84 22.79 9.74 9.29-1.11 22.57-9.08 32.97-15.49 10.4-6.42 17.92-11.29 26.77-9.74 8.86 1.55 19.03 9.52 29.43 13.94 10.4 4.43 21.03 5.31 31.65 3.54 10.62-1.77 21.24-6.19 29.65-11.06s14.6-10.18 23.01-9.96c8.41.22 19.03 5.98 28.77 8.85 9.74 2.88 18.59 2.88 27.66 1.33 9.07-1.55 18.37-4.65 26.11-8.19 7.75-3.54 13.94-7.52 21.24-7.52 7.31 0 15.71 3.98 21.69 8.41 5.97 4.42 9.51 9.29 16.6 9.51 7.08.22 17.7-4.2 26.55-8.41 8.85-4.2 15.93-8.18 20.58-11.94 4.65-3.77 6.86-7.31 9.07-10.85"
                            id="path150"
                        />
                    </g>
                </g>
            </svg>
        </Tooltip>
    )
}